/**
 * Added to frames that needs more than one suspension rail.
 * Used by SuspensionRailSystem
 */
class SuspensionRailsComponent {
    constructor(nbrOfRails) {
        this.typeId = SuspensionRailsComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.nbrOfRails = nbrOfRails;
    }
    eq(other) {
        return this.nbrOfRails === other.nbrOfRails;
    }
}
SuspensionRailsComponent.id = 2065;
export default SuspensionRailsComponent;
//# sourceMappingURL=SuspensionRailsComponent.js.map